// extracted by mini-css-extract-plugin
export default {"-large":"kwp1VLoqlOdh1LJn2x_u","signupLink":"mhYHgFehZciyQcKvTz8f","backHeadingContainer":"G4TGJcHMOk8DiFrKAFQy","iconContainer":"onPL2ljY6gp0dPdbdo7S"};